export const toTitleCase = (str) => str.replace(
  /\w\S*/g,
  (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
);

export const nameWithPossesive = (name) => {
  if (name.endsWith('s')) return `${name}'`;
  return `${name}'s`;
};

export const getUserPossesivePronoun = (gender) => {
  let result = 'their';

  if (gender === 'boy') {
    result = 'his';
  } else if (gender === 'girl') {
    result = 'her';
  }

  return result;
};
